import { Linkedin, Twitter, ExternalLink, Award } from 'lucide-react';

const LOGO_URL = "/Logo.png";

const socialLinks = [
    { name: 'Upwork', href: 'https://www.upwork.com/freelancers/spartha', icon: "/Upwork.png" },
    { name: 'LinkedIn', href: 'https://linkedin.com/in/mrparrth', icon: Linkedin },
];
// { name: 'Twitter', href: 'https://twitter.com/mrparrth', icon: Twitter },

export const Footer = () => {
    return (
        <footer className="py-12 bg-white border-t border-[#E5E5E5]" data-testid="footer-section">
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                    {/* Logo & Badge */}
                    <div className="flex flex-col items-center md:items-start gap-2">
                        <div className="flex items-center gap-3">
                            <img 
                                src={LOGO_URL} 
                                alt="Digital Enabler HQ" 
                                className="h-8 w-auto"
                            />
                            <span className="text-[#2C2C2C] font-medium">Digital Enabler HQ</span>
                        </div>
                    </div>

                    {/* Social Links */}
                    <div className="flex items-center gap-4">
                        {socialLinks.map((social) => (
                            <a
                                key={social.name}
                                href={social.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 rounded-full bg-[#FAFAFA] border border-[#E5E5E5] flex items-center justify-center text-[#6B6B6B] hover:text-[#34A853] hover:border-[#34A853] transition-colors duration-200"
                                data-testid={`social-link-${social.name.toLowerCase()}`}
                                aria-label={social.name}
                            >
                                {typeof social.icon === 'string' ? (
                                    <img src={social.icon} alt={social.name} className="w-[18px] h-[18px] object-contain" />
                                ) : (
                                    <social.icon size={18} />
                                )}
                            </a>
                        ))}
                    </div>

                    {/* Copyright */}
                    <p className="text-[#6B6B6B] text-sm">
                        © {new Date().getFullYear()} Digital Enabler HQ
                    </p>
                </div>
            </div>
        </footer>
    );
};
